<template>
  <div class="row">
    <div class="col-md-6">
      <p>{{ car.id }}</p>
    </div>
    <div class="col-md-6">
      <p>{{ car.km }} Km</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RouteName',
  props: {
    car: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="stylus">

</style>
